var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWaiAria = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.682 8.678 2.049 2.027 0 2.015l.107.314L2.92 12.644l.398 1.462h.908l.367-1.481 1.21-4.892-.71-3.063-.16-.562-1.205 4.639z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m7.918 8.54-1.68-6.513L4.222 2l.088.25.66 2.422.835 3.06 1.318 4.835.42 1.54h.848l.401-1.552 2.245-8.645 2.185-.019-2.494 4.438 1.342.111c.064.007 1.68.177 2.07 1.53.296 1.023.093 1.927-.54 2.422a1.46 1.46 0 0 1-1.664.1c-.454-.265-.525-.56-.645-1.051q-.027-.115-.058-.235l-1.672.441q.027.094.05.202c.146.597.363 1.5 1.453 2.136 1.148.668 2.56.579 3.598-.23 1.193-.93 1.631-2.564 1.14-4.265-.413-1.433-1.49-2.13-2.357-2.466l2.13-3.79-.063-1.207-5.823.022-1.725 6.56z"
})));
export default SvgWaiAria;